// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2pVeP","name":"Header_name__22vbF","birthday":"Header_birthday__1ZL4E","skeleton":"Header_skeleton__3Hjvj"};